export default __webpack_public_path__ + "static/media/webconfigurator.d51bdffb.png";